export const formatYear = (year, language) => {
  if (year === 9999) {
    return language === "ru" ? "скоро выйдет" : "to be announced";
  }
  return year ? ` (${year})` : "";
};

export const formatDate = (dateStr, lang = 'en') => {
  const date = new Date(dateStr);
  let formatted = date.toLocaleDateString(lang === 'ru' ? 'ru-RU' : 'en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  return lang === 'ru' ? formatted.replace(' г.', '').trim() : formatted;
};